import { render, staticRenderFns } from "./legalActivities.vue?vue&type=template&id=80e268a2&scoped=true"
import script from "./legalActivities.vue?vue&type=script&lang=js"
export * from "./legalActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e268a2",
  null
  
)

export default component.exports